import { Link, useLocation } from 'react-router-dom';
import Button from '../Button';
const TeacherSidebar = ({ side, closeSidebar }) => {
  const location = useLocation();
  const isActive = (route) => location.pathname.includes(route);

  return (
    <div
      style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
      className={`fixed top-0  ${side} sm:left-0 w-64 overflow-x-auto h-full bg-white z-10 transition-all`}
    >
      <i
        className="bi bi-x-lg absolute text-black top-4 right-4 sm:hidden block cursor-pointer text-lg"
        onClick={closeSidebar}
      ></i>
      <div className="p-5 flex justify-between flex-col h-full">
        <div className=" flex flex-col gap-4">
          <div className="  ">
            {/* <h1 className=" text-white text-4xl  font-bold">
          CEAT
        </h1> */}
            <img className='h-[200px]' src={require('../../assets/image/admin_logo_2.jpg')} alt="" />
          </div>

          <ul className=" flex flex-col  gap-2">
            <li
              className={` ${
                isActive('/teacher-dashboard') ? ' bg-primary text-white' : ''
              } px-4  rounded-lg cursor-pointer       transition-all py-2 text-black flex items-center `}
            >
              <svg
                width="27"
                className=" mr-2"
                height="27"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.47213 11.4454C12.4493 7.46817 14.4379 5.47957 16.8448 5.09835C17.6221 4.97524 18.414 4.97524 19.1913 5.09835C21.5982 5.47957 23.5868 7.46817 27.564 11.4454V11.4454C29.2956 13.1769 30.1613 14.0427 30.7006 15.1011C30.879 15.4512 31.0296 15.8147 31.151 16.1884C31.5181 17.3181 31.5181 18.5425 31.5181 20.9913V27.3994C31.5181 29.8847 29.5034 31.8994 27.0181 31.8994V31.8994C24.5328 31.8994 22.5181 29.8847 22.5181 27.3994V25.8994C22.5181 23.4141 20.5034 21.3994 18.0181 21.3994V21.3994C15.5328 21.3994 13.5181 23.4141 13.5181 25.8994V27.3994C13.5181 29.8847 11.5033 31.8994 9.01807 31.8994V31.8994C6.53279 31.8994 4.51807 29.8847 4.51807 27.3994V20.9913C4.51807 18.5425 4.51807 17.3181 4.88514 16.1884C5.00656 15.8147 5.15714 15.4512 5.33552 15.1011C5.87481 14.0427 6.74058 13.1769 8.47213 11.4454V11.4454Z"
                  stroke={`${isActive('/teacher-dashboard') ? '#fff' : '#1C1D1D'}`}
                  stroke-width="2.25"
                  stroke-linejoin="round"
                />
              </svg>

              <Link to="/teacher-dashboard" className="text-lg capitalize">
                Dashboard
              </Link>
            </li>

            <li
              className={` ${
                isActive('/teacher-cources') ? ' bg-primary text-white' : ''
              } px-4  cursor-pointer  rounded-lg    transition-all py-2 text-black flex items-center`}
            >
              <svg
                width="27"
                className=" mr-2"
                height="27"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.8789 14.4637V23.5618C27.8789 24.5235 27.8789 25.0043 27.7007 25.4251C27.642 25.5636 27.5696 25.6959 27.4845 25.8199C27.226 26.1968 26.8209 26.4558 26.0107 26.9739L20.8239 30.2905C19.8848 30.891 19.4152 31.1912 18.8976 31.2504C18.7278 31.2698 18.5564 31.2698 18.3867 31.2504C17.869 31.1912 17.3994 30.891 16.4603 30.2905L11.2735 26.9739C10.4633 26.4558 10.0582 26.1968 9.79969 25.8199C9.71462 25.6959 9.64221 25.5636 9.58353 25.4251C9.40525 25.0043 9.40525 24.5235 9.40525 23.5618V14.4637M32.1421 12.3998L20.3356 6.96509C19.5963 6.62479 19.2267 6.45464 18.836 6.42085C18.707 6.40969 18.5772 6.40969 18.4482 6.42085C18.0575 6.45464 17.6879 6.62479 16.9486 6.96509L5.14209 12.3998L16.8773 18.0812C17.6464 18.4535 18.0309 18.6397 18.4395 18.6766C18.5743 18.6888 18.7099 18.6888 18.8447 18.6766C19.2533 18.6397 19.6378 18.4535 20.4069 18.0812L32.1421 12.3998ZM32.1421 12.3998V26.2856C32.1421 27.167 32.1421 27.6077 31.9891 28.0011C31.9386 28.1309 31.8763 28.2556 31.8028 28.3738C31.5798 28.7323 31.2272 28.9967 30.5221 29.5256L28.7671 30.8418"
                  stroke={`${isActive('/teacher-cources') ? '#fff' : '#1C1D1D'}`}
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <Link to="/teacher-cources" className="text-lg capitalize">
                Courses
              </Link>
            </li>
            <li
              className={` ${
                isActive('/attendance') ? ' bg-primary text-white' : ''
              } px-4  cursor-pointer rounded-xl  transition-all py-2 text-black flex items-center `}
            >
              <svg
                width="27"
                height="27"
                className=" mr-2"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M31.0166 6.13721H6.2666C5.66986 6.13721 5.09757 6.37426 4.67561 6.79622C4.25365 7.21817 4.0166 7.79047 4.0166 8.38721V28.6372C4.0166 29.2339 4.25365 29.8062 4.67561 30.2282C5.09757 30.6502 5.66986 30.8872 6.2666 30.8872H8.14957C8.36249 30.8873 8.57105 30.8269 8.75103 30.7132C8.931 30.5994 9.075 30.4369 9.16629 30.2445C9.71335 29.0896 10.5771 28.1136 11.657 27.4302C12.7369 26.7468 13.9886 26.384 15.2666 26.384C16.5446 26.384 17.7963 26.7468 18.8762 27.4302C19.9562 28.1136 20.8199 29.0896 21.3669 30.2445C21.4582 30.4369 21.6022 30.5994 21.7822 30.7132C21.9622 30.8269 22.1707 30.8873 22.3836 30.8872H31.0166C31.6133 30.8872 32.1856 30.6502 32.6076 30.2282C33.0295 29.8062 33.2666 29.2339 33.2666 28.6372V8.38721C33.2666 7.79047 33.0295 7.21817 32.6076 6.79622C32.1856 6.37426 31.6133 6.13721 31.0166 6.13721ZM11.8916 20.7622C11.8916 20.0947 12.0895 19.4422 12.4604 18.8872C12.8312 18.3321 13.3583 17.8996 13.975 17.6441C14.5917 17.3887 15.2703 17.3218 15.925 17.4521C16.5797 17.5823 17.1811 17.9037 17.6531 18.3757C18.1251 18.8477 18.4465 19.4491 18.5768 20.1038C18.707 20.7585 18.6401 21.4371 18.3847 22.0538C18.1292 22.6705 17.6967 23.1976 17.1417 23.5684C16.5866 23.9393 15.9341 24.1372 15.2666 24.1372C14.3715 24.1372 13.5131 23.7816 12.8801 23.1487C12.2472 22.5158 11.8916 21.6573 11.8916 20.7622ZM31.0166 28.6372H23.0614C22.122 27.022 20.7058 25.737 19.0072 24.9585C19.8588 24.2002 20.4599 23.201 20.7307 22.0933C21.0015 20.9857 20.9292 19.8219 20.5236 18.7562C20.1179 17.6905 19.3979 16.7733 18.4591 16.1262C17.5202 15.479 16.4069 15.1325 15.2666 15.1325C14.1263 15.1325 13.013 15.479 12.0741 16.1262C11.1353 16.7733 10.4153 17.6905 10.0096 18.7562C9.60396 19.8219 9.53173 20.9857 9.80253 22.0933C10.0733 23.201 10.6744 24.2002 11.526 24.9585C9.82737 25.737 8.41122 27.022 7.47176 28.6372H6.2666V8.38721H31.0166V28.6372ZM8.5166 14.0122V11.7622C8.5166 11.4638 8.63513 11.1777 8.84611 10.9667C9.05709 10.7557 9.34323 10.6372 9.6416 10.6372H27.6416C27.94 10.6372 28.2261 10.7557 28.4371 10.9667C28.6481 11.1777 28.7666 11.4638 28.7666 11.7622V25.2622C28.7666 25.5606 28.6481 25.8467 28.4371 26.0577C28.2261 26.2687 27.94 26.3872 27.6416 26.3872H25.3916C25.0932 26.3872 24.8071 26.2687 24.5961 26.0577C24.3851 25.8467 24.2666 25.5606 24.2666 25.2622C24.2666 24.9638 24.3851 24.6777 24.5961 24.4667C24.8071 24.2557 25.0932 24.1372 25.3916 24.1372H26.5166V12.8872H10.7666V14.0122C10.7666 14.3106 10.6481 14.5967 10.4371 14.8077C10.2261 15.0187 9.93997 15.1372 9.6416 15.1372C9.34323 15.1372 9.05709 15.0187 8.84611 14.8077C8.63513 14.5967 8.5166 14.3106 8.5166 14.0122Z"
                  stroke={`${isActive('/attendance') ? '#fff' : '#1C1D1D'}`}
                />
              </svg>

              <Link to="/attendance" className="text-lg capitalize">
                Attendance
              </Link>
            </li>
          </ul>
        </div>

        <Button
          IconLeft={<img src={require('../../assets/image/logout.png')} alt="" />}
          className={' bg-transparent   py-3 w-full border border-[#FF1F00] text-black'}
          label={'Logout'}
          onClick={() => {
            localStorage.clear();
            window.location.reload();
          }}
        />
      </div>
    </div>
  );
};
export default TeacherSidebar;
